<template>
  <div class="application">
    <slot name="top-content" />
    <GreyCard
      class="application-card"
      :class="{ 'flex-row': flex, noTopLeftBorder, noTopRightBorder }"
    >
      <div class="card-content">
        <slot />
      </div>
    </GreyCard>
  </div>
</template>

<script>
import GreyCard from '@/components/GreyCard.vue';
export default {
  components: {
    GreyCard
  },
  props: {
    flex: {
      type: Boolean,
      default: false
    },
    noTopLeftBorder: {
      type: Boolean,
      default: false
    },
    noTopRightBorder: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.application {
  width: 400px;
  display: flex;
  flex-direction: column;
}
.application-card {
  width: 100%;
  min-height: 300px;
  border: 1px solid var(--active-card-border);
  position: relative;
  z-index: 1;
}
.application-card.flex-row {
  display: grid;
  gap: 1px;
  grid-template-columns: repeat(2, 1fr);
}

.card-content {
  line-height: 1.5;
  font-size: 1.2rem;
  margin-bottom: 2rem;
}
.card-content:nth-last-child(1) {
  margin-bottom: 0;
}
.card-content > h3 {
  font-weight: 700;
  margin-bottom: 5px;
}
.card-content > h4 {
  line-height: 1.3;
}
.card-content > p {
  font-weight: 400;
}
.noTopLeftBorder {
  border-top-left-radius: 0;
}

.noTopRightBorder {
  border-top-right-radius: 0;
}
</style>
